export default __webpack_public_path__ + "static/media/clave.1ee97b83.mp3";